import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DownloadSimple, ShareNetwork, X } from "@phosphor-icons/react";


export default function PwaInstallPrompt() {
  const { pathname } = useLocation();
  const [installEvent, setInstallEvent] = useState(null);
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem("jyoti-pwa-install-dismissed") === "yes"
  );

  const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  const mobile = window.matchMedia("(max-width: 767px)").matches;
  const ios = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
  const eligiblePage = pathname === "/login" || pathname === "/client-login";

  useEffect(() => {
    const capturePrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
    };
    const installed = () => setInstallEvent(null);
    window.addEventListener("beforeinstallprompt", capturePrompt);
    window.addEventListener("appinstalled", installed);
    return () => {
      window.removeEventListener("beforeinstallprompt", capturePrompt);
      window.removeEventListener("appinstalled", installed);
    };
  }, []);

  if (standalone || !mobile || !eligiblePage || dismissed || (!ios && !installEvent)) return null;

  const dismiss = () => {
    sessionStorage.setItem("jyoti-pwa-install-dismissed", "yes");
    setDismissed(true);
  };

  const install = async () => {
    if (!installEvent) return;
    await installEvent.prompt();
    const choice = await installEvent.userChoice;
    setInstallEvent(null);
    if (choice.outcome === "accepted") {
      sessionStorage.setItem("jyoti-pwa-install-dismissed", "yes");
      setDismissed(true);
    }
  };

  return (
    <aside className="pwa-install-prompt" aria-label="Install Jyoti Image mobile app">
      <img src="/icons/jyoti-image-64.png" alt="" className="pwa-install-icon" />
      <div className="min-w-0 flex-1">
        <div className="font-heading font-black text-sm text-white">Install Jyoti Image</div>
        {ios ? (
          <div className="mt-1 text-xs text-white/80 flex items-center gap-1.5">
            Tap <ShareNetwork size={15} weight="bold" /> Share, then <strong>Add to Home Screen</strong>.
          </div>
        ) : (
          <div className="mt-1 text-xs text-white/75">Open the workflow like a mobile app from your home screen.</div>
        )}
      </div>
      {!ios && (
        <button type="button" onClick={install} className="pwa-install-action">
          <DownloadSimple size={15} weight="bold" /> Install
        </button>
      )}
      <button type="button" onClick={dismiss} className="pwa-install-close" aria-label="Dismiss install instructions">
        <X size={15} />
      </button>
    </aside>
  );
}
